import { render, staticRenderFns } from "./KdsItem.vue?vue&type=template&id=2dd63a40&scoped=true"
import script from "./KdsItem.vue?vue&type=script&lang=js"
export * from "./KdsItem.vue?vue&type=script&lang=js"
import style0 from "./KdsItem.vue?vue&type=style&index=0&id=2dd63a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd63a40",
  null
  
)

export default component.exports